export default __webpack_public_path__ + "static/6791-b6e18d7e952fd7fe86eb66705bed9e2d.jpg";